'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CollapsedListItem = require('./CollapsedListItem');

var _CollapsedListItem2 = _interopRequireDefault(_CollapsedListItem);

var _SearchListItem = require('./SearchListItem');

var _SearchListItem2 = _interopRequireDefault(_SearchListItem);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

var _IconButton = require('../IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _Add = require('../SvgIcon/Add');

var _Add2 = _interopRequireDefault(_Add);

var _Text = require('../Text');

var _Text2 = _interopRequireDefault(_Text);

var _makeSortable = require('./makeSortable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('List', function (theme) {
  return {
    root: {
      flex: '1 1 auto',
      listStyle: 'none',
      margin: 0,
      padding: 0
    },
    divider: {
      borderTop: '1px solid ' + theme.palette.text.lightDivider
    },
    add: {
      backgroundColor: 'inherit'
    },
    padding: {
      paddingTop: theme.typography.rhythmByUnit(1),
      paddingBottom: theme.typography.rhythmByUnit(1)
    },
    subheader: {
      paddingTop: 0
    },
    icon: {
      width: '1em'
    }
  };
});

/**
 * A simple list component.
 */
var List = (_temp2 = _class = function (_Component) {
  _inherits(List, _Component);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = List.__proto__ || Object.getPrototypeOf(List)).call.apply(_ref, [this].concat(args))), _this), _this.state = Object.assign({
      displayChildren: _this.getDisplayChildren(_react.Children.toArray(_this.props.children), _this.props.collapse)
    }, _this.props.add && { add: '' }), _this.handleAddSubmit = function (e) {
      if (e.key === 'Enter' || e.currentTarget.type === 'submit' && e.type === 'click') {
        var onAddRequest = _this.props.onAddRequest;
        var value = _this.state.add;
        var error = _this.addInput.state.error;


        if (value && !error) {
          onAddRequest(value);
          _this.setState({ add: '', addError: false });
        } else {
          _this.setState({ addError: true });
        }
      }
    }, _this.handleAddInputChange = function (e) {
      var value = e.target.value;

      _this.setState(function (state) {
        return state.addError ? { add: value, addError: !value } : { add: value };
      });
    }, _this.renderChildren = function () {
      return _react.Children.map(_this.state.displayChildren, function (child) {
        var _child$type = child.type;
        _child$type = _child$type === undefined ? {} : _child$type;
        var _child$type$propTypes = _child$type.propTypes;
        _child$type$propTypes = _child$type$propTypes === undefined ? {} : _child$type$propTypes;
        var dividerPropType = _child$type$propTypes.divider;


        return _react2['default'].cloneElement(child, Object.assign({}, dividerPropType !== undefined && { divider: _this.props.divider }));
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(nextProps) {
        var children = nextProps.children,
            collapse = nextProps.collapse,
            add = nextProps.add;


        this.setState(Object.assign({
          displayChildren: this.getDisplayChildren(_react.Children.toArray(children), collapse)
        }, add && { add: '' }));
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'getDisplayChildren',
    value: function () {
      function getDisplayChildren(children, collapse) {
        var _this2 = this;

        if (!collapse) {
          return children;
        }

        var shouldCollapse = children.map(function (child) {
          return collapse(child.props);
        });
        var newChildren = [];
        var count = 0;

        shouldCollapse.forEach(function (collapse, i) {
          if (collapse) {
            count++;

            if (i === children.length - 1) {
              newChildren.push(_this2.renderCollapsedListItem(children, count, i, i - count + 1));
            }
          } else {
            if (count > 0) {
              newChildren.push(_this2.renderCollapsedListItem(children, count, i, i - count));
              count = 0;
            }

            newChildren.push(children[i]);
          }
        });

        return newChildren;
      }

      return getDisplayChildren;
    }()
  }, {
    key: 'renderCollapsedListItem',
    value: function () {
      function renderCollapsedListItem(children, count, i, startIdx) {
        var _this3 = this;

        var collapsedLabel = this.props.collapsedLabel;

        var replacementItems = children.slice(startIdx, startIdx + count);
        var label = collapsedLabel && collapsedLabel(replacementItems.map(function (c) {
          return c.props;
        }));

        return _react2['default'].createElement(_CollapsedListItem2['default'], _extends({
          id: i,
          key: i,
          onClick: function () {
            function onClick(e, _ref2) {
              var id = _ref2.id,
                  onExpand = _ref2.onExpand;

              var displayChildren = _this3.state.displayChildren.slice();
              var idxToReplace = displayChildren.findIndex(function (el) {
                return el.props.id === id;
              });

              displayChildren.splice.apply(displayChildren, [idxToReplace, 1].concat(_toConsumableArray(replacementItems)));

              _this3.setState({ displayChildren: displayChildren });

              if (onExpand) {
                replacementItems.map(function (i) {
                  return onExpand(i.props);
                });
              }
            }

            return onClick;
          }()
        }, { count: count, label: label, startIdx: startIdx }));
      }

      return renderCollapsedListItem;
    }()
  }, {
    key: 'renderAdd',
    value: function () {
      function renderAdd(classes) {
        var _this4 = this;

        var _props = this.props,
            placeholder = _props.addPlaceholder,
            Component = _props.addComponent,
            errorMessage = _props.addErrorMessage,
            validator = _props.validator;
        var _state = this.state,
            value = _state.add,
            error = _state.addError;

        var detailPrimaryComponent = !error ? null : _react2['default'].createElement(
          _Text2['default'],
          { component: 'div', error: true },
          errorMessage
        );

        return _react2['default'].createElement(Component, {
          primary: _react2['default'].createElement(_Input2['default'], _extends({
            id: 'add',
            fullWidth: true,
            forceDirty: true,
            className: classes.add,
            onChange: this.handleAddInputChange,
            onKeyPress: this.handleAddSubmit,
            ref: function () {
              function ref(c) {
                return _this4.addInput = c;
              }

              return ref;
            }()
          }, { error: error, errorMessage: errorMessage, placeholder: placeholder, validator: validator, value: value })),
          detailPrimary: detailPrimaryComponent,
          icon: _react2['default'].createElement(
            _IconButton2['default'],
            {
              type: 'submit',
              sizeInherit: true,
              className: classes.icon,
              onClick: this.handleAddSubmit,
              ripple: false
            },
            _react2['default'].createElement(_Add2['default'], null)
          )
        });
      }

      return renderAdd;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _classNames;

        var _props2 = this.props,
            add = _props2.add,
            addComponent = _props2.addComponent,
            addErrorMessage = _props2.addErrorMessage,
            addPlaceholder = _props2.addPlaceholder,
            childrenProp = _props2.children,
            classNameProp = _props2.className,
            collapse = _props2.collapse,
            collapsedLabel = _props2.collapsedLabel,
            ComponentProp = _props2.component,
            divider = _props2.divider,
            getContainer = _props2.getContainer,
            onAddRequest = _props2.onAddRequest,
            onExpand = _props2.onExpand,
            onSort = _props2.onSort,
            padding = _props2.padding,
            rootRef = _props2.rootRef,
            sortable = _props2.sortable,
            subheader = _props2.subheader,
            useWindowAsScrollContainer = _props2.useWindowAsScrollContainer,
            validator = _props2.validator,
            other = _objectWithoutProperties(_props2, ['add', 'addComponent', 'addErrorMessage', 'addPlaceholder', 'children', 'className', 'collapse', 'collapsedLabel', 'component', 'divider', 'getContainer', 'onAddRequest', 'onExpand', 'onSort', 'padding', 'rootRef', 'sortable', 'subheader', 'useWindowAsScrollContainer', 'validator']);

        var children = this.renderChildren();
        var classes = this.context.styleManager.render(styleSheet);
        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes.divider, divider && _react.Children.count(children)), _defineProperty(_classNames, classes.padding, padding), _defineProperty(_classNames, classes.subheader, subheader), _classNames), classNameProp);

        return _react2['default'].createElement(
          ComponentProp,
          _extends({ ref: rootRef }, Object.assign({ className: className }, other)),
          subheader,
          sortable ? _react2['default'].createElement(
            _makeSortable.SortableList,
            {
              getContainer: getContainer,
              onSort: onSort,
              useWindowAsScrollContainer: useWindowAsScrollContainer
            },
            children
          ) : children,
          add && this.renderAdd(classes)
        );
      }

      return render;
    }()
  }]);

  return List;
}(_react.Component), _class.propTypes = {
  /**
   * If true, add node appears as last list item
   */
  add: _PropTypes2['default'].bool,
  /**
   * The component used for the add node.
   * Either a string to use a DOM element or a ReactComponent.
   */
  addComponent: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Error message displayed by add input
   */
  addErrorMessage: _PropTypes2['default'].string,
  /**
   * Text used as add list item input placeholder text
   */
  addPlaceholder: _PropTypes2['default'].string,
  children: _PropTypes2['default'].node,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * Function that takes a list item's props as argument and collapses item if it returns true.
   */
  collapse: _PropTypes2['default'].func,
  /**
   * Function callback that is called once for each collapsed section of the list with the props of the collapsed
   * components in that secion. Returns a string is shown as the label of the collapsed secion.
   */
  collapsedLabel: _PropTypes2['default'].func,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a ReactComponent.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * Children inherit this prop.  Also, if true and children exist, Divider is presented at top and bottom of list.
   */
  divider: _PropTypes2['default'].bool,
  /**
   * Optional function to return the scrollable container element.
   */
  getContainer: _PropTypes2['default'].func,
  /**
   * @ignore
   */
  id: _PropTypes2['default'].string,
  /**
   * Callback fired when add is requested.
   */
  onAddRequest: _PropTypes2['default'].func,
  /**
   * Function callback when a collapsed list item is expanded, which is passed the properties of the expaned item.
   */
  onExpand: _PropTypes2['default'].func,
  /**
   * Callback fired list is sorted.
   */
  onSort: _PropTypes2['default'].func,
  padding: _PropTypes2['default'].bool,
  /**
   * @ignore
   */
  rootRef: _PropTypes2['default'].func,
  /**
   * If true, user can sort list.
   */
  sortable: _PropTypes2['default'].bool,
  subheader: _PropTypes2['default'].node,
  /**
   * If true, set the window as the scrolling container.
   */
  useWindowAsScrollContainer: _PropTypes2['default'].bool,
  /**
   * Function that validates the added value
   */
  validator: _PropTypes2['default'].func
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _class.defaultProps = {
  add: false,
  addComponent: _SearchListItem2['default'],
  addErrorMessage: 'Please enter a valid value',
  addPlaceholder: 'Add to list',
  component: 'div',
  onAddRequest: function () {
    function onAddRequest() {}

    return onAddRequest;
  }(),
  onSort: function () {
    function onSort(v) {
      return v;
    }

    return onSort;
  }(),
  padding: true,
  sortable: false
}, _temp2);
exports['default'] = List;


List.displayName = 'List';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/List.js
// module id = 1672
// module chunks = 32